import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Skeleton from "@material-ui/lab/Skeleton";
import { sendMessage } from "../redux/actions/websocketActions";
import { createWebsocketMessage } from "./../utils/KpsUtils";
import Chip from "@material-ui/core/Chip";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import CloudIcon from "@material-ui/icons/CloudQueue";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import shortid from "shortid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import DoneIcon from "@material-ui/icons/Done";
import { List, AutoSizer } from "react-virtualized";
import MaterialList from "@material-ui/core/List";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { Trans, withTranslation } from "react-i18next";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormLabel from "@material-ui/core/FormLabel";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AddUserDialog from "./AddUserDialog";
import AddTeamDialog from "./AddTeamDialog";
import ProfilePage from "./user-profile/ProfilePage";
import languages from "../resources/languages.json";
import WarningIcon from "@material-ui/icons/Warning";
import Typography from "@material-ui/core/Typography";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Tooltip from "@material-ui/core/Tooltip";
import UserAutosuggest from "./../components/UserAutosuggest";
import axios from "../AxiosClient";
import { taxServiceClient } from "../AxiosClient";
import FilterableList from "./components/FilterableList.js";
import { Accordion } from "@material-ui/core";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PropertyNames from "../PropertyNames";
import ActionButton from "../components/ActionButton";
import { withSnackbar } from "notistack";
import ButtonMenu from "../components/ButtonMenu";
import PasswordRequirementsDialog from "./PasswordRequirementsDialog";
import Alert from "@material-ui/lab/Alert";
import { fetchLicence } from "../utils/LicenceUtils";
import { Virtuoso } from "react-virtuoso";
import { currentUserHasRole, Role } from "../utils/RoleUtils";

const organizationSVG =
  "M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z";
const styles = (theme) => ({
  orgContainer: {
    width: "100%",
  },
  orgInnerContainer: {
    // flex: 0.3,
  },
  pageContainer: {
    display: "flex",
    margin: 10,
    height: "100%",
  },
  leftDiv: {
    display: "flex",
    flexDirection: "column",
    flex: 0.3,
  },
  userListContainer: {
    // flex: 0.3,
    height: "100%",
  },
  operatorChip: {
    marginLeft: 5,
  },
  userSettingsContainer: {
    width: "100%",
    height: "100%",
    marginLeft: 15,
    flex: 0.7,
  },
  settingsCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  settingsCardContent: {
    flex: 1,
  },
  userSettingsCardContent: {
    flex: "1",
    overflow: "auto",
  },
  adminSettings: {
    display: "flex",
    flexDirection: "column",
  },
  teamChip: {
    marginTop: 10,
    marginRight: 10,
  },
  teamFilterInput: {
    width: "60%",
  },
  activeSwitch: {
    flex: 0.1,
  },
  userTypeSelect: {
    flex: 0.15,
    marginTop: -10,
  },
  passwordInput: {
    flex: 0.2,
    marginRight: 15,
  },
  forcePasswordChange: {
    marginBottom: 30,
  },
  groupDiv: {
    marginBottom: 25,
  },
  tabs: {
    backgroundColor: theme.palette.grey[100],
  },
  denseList: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  cannotEditIcon: {
    marginBottom: -8,
    marginRight: 7,
  },
  cannotEdit: {
    color: theme.palette.error.main,
  },
  userSearchContainer: {
    display: "flex",
    padding: "0 20px",
  },
  autosuggestInput: {
    flex: 1,
  },
  toggleContainer: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    background: theme.palette.background.default,
    marginLeft: 15,
    borderRadius: 10,
  },
  panelSummaryIcon: {
    marginRight: theme.spacing(1),
  },
});

export class UserAdministration extends Component {
  constructor() {
    super();
    this.userListRef = React.createRef();
  }
  state = {
    instance: new Date().getTime().toString(),
    input: "",
    users: [],
    unfilteredUsers: [],
    teams: [],
    selectedUser: {},
    selectedUserTeams: [],
    selectedUserTeamsToRemove: [],
    newPassword: "",
    newPasswordVerify: "",
    teamFilter: "",
    activeTab: 0,
    addUserDialogOpen: false,
    searchFilter: "all",
    organization: null,
    expandedPanel: "",
    saving: false,
    openPasswordRequirementsDialog: false,
    isAtEnd: false,
    page: 0,
    savingNewUser: false,
    saveDisabled: false,
    menuOpen: false,
  };

  componentDidMount() {
    this.getData();
  }
  componentDidUpdate(prevProps, prevState) {
    prevState.organization !== this.state.organization && this.getData();
  }

  getData = () => {
    if (this.state.isAtEnd) return;
    let userUrl =
      this.props.currentUser.isOperator === 1 &&
      this.state.organization !== null
        ? "/user/?orgId=" + this.state.organization.organizationId + "&"
        : "/user/?";
    let teamUrl =
      this.props.currentUser.isOperator === 1 &&
      this.state.organization !== null
        ? "/team/?orgId=" + this.state.organization.organizationId + "&"
        : "/team/?";

    taxServiceClient
      .get(`${userUrl}page=${this.state.page}&size=20`)
      .then((res) => {
        if (res.data.last) {
          this.setState({ isAtEnd: true });
        } else {
          this.setState({ page: this.state.page + 1 });
        }
        if (res.data.number === 0) {
          this.setState({
            users: res.data.content,
          });
        } else {
          this.setState({ users: [...this.state.users, ...res.data.content] });
        }
      });
    taxServiceClient.get(`${teamUrl}page=0&size=1000`).then((res) => {
      if (Object.keys(this.state.selectedUser).length > 0) {
        this.setState({
          selectedUserTeams: res.data.content.map((ele) => {
            return ele;
          }),
        });
      } else {
        this.setState({
          teams: res.data.content.map((ele) => {
            return ele;
          }),
        });
      }
    });
  };

  userManagedExternally = () => {
    return (
      this.state.selectedUser.provider &&
      this.state.selectedUser.provider !== "uks" &&
      this.props.properties[PropertyNames.EXTERNAL_AUTH_CONTAINS_USER_STATE] ===
        "true" &&
      this.props.properties[PropertyNames.AUTHENTICATION_TYPE] !== "database"
    );
  };

  render() {
    const { classes, t } = this.props;
    return (
      <div className={classes.pageContainer}>
        <div className={classes.leftDiv}>
          {this.props.currentUser && (
            <>
              {this.props.currentUser.isOperator === 1 && (
                <div className={classes.orgInnerContainer}>
                  <Accordion
                    key="organization"
                    className={classes.expansionPanel}
                    expanded={
                      this.state.expandedPanel === "organizationSelection"
                    }
                    onChange={this.handlePanelChange("organizationSelection")}
                  >
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <div className={classes.panelSummaryIcon}>
                        <svg height="24px" width="24px">
                          <path
                            fill={this.state.organizationColourTheme}
                            d={organizationSVG}
                          />
                        </svg>
                      </div>
                      <Typography className={classes.heading}>
                        {this.state.organization !== null
                          ? "Organization : " +
                            this.state.organization.organizationName
                          : "Organization"}
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className={classes.orgContainer}>
                        <FilterableList
                          dataurl="/organization/"
                          name="organizationName"
                          secondary=""
                          iconColour={this.state.organizationColourTheme}
                          iconSVG={organizationSVG}
                          onItemSelected={this.organizationSelected}
                        />
                      </div>
                    </ExpansionPanelDetails>
                  </Accordion>
                </div>
              )}
            </>
          )}

          <div className={classes.userListContainer}>
            <Card className={classes.settingsCard}>
              {this.props.licence &&
                this.props.licence.usedUsers >=
                  this.props.licence.namedUsers && (
                  <Alert
                    severity="warning"
                    style={{ margin: 10, marginBottom: 0 }}
                  >
                    {t("create_user_licence_user_limit_reached")}
                  </Alert>
                )}
              <CardHeader
                title={t("user_admin_select_a_user")}
                action={
                  <ButtonMenu
                    ariaLabel="User administration options"
                    open={this.state.menuOpen}
                    onOpen={() => this.setState({ menuOpen: true })}
                    onClose={() => this.setState({ menuOpen: false })}
                  >
                    <MenuItem
                      id="user-admin-create-user"
                      onClick={() => {
                        this.setState({ menuOpen: false });
                        this.openAddUserDialog();
                      }}
                      disabled={
                        this.props.licence &&
                        this.props.licence.usedUsers >=
                          this.props.licence.namedUsers
                      }
                    >
                      <Trans i18nKey="user_admin_create_user" />
                    </MenuItem>
                    <MenuItem
                      id="user-admin-create-team"
                      onClick={() =>
                        this.setState({
                          menuOpen: false,
                          openAddTeamDialog: true,
                        })
                      }
                    >
                      <Trans i18nKey="create_new_team" />
                    </MenuItem>
                    <MenuItem
                      id="user-admin-password-requirements"
                      onClick={() =>
                        this.setState({
                          menuOpen: false,
                          openPasswordRequirementsDialog: true,
                        })
                      }
                    >
                      <Trans i18nKey="change_password_strength_requirements" />
                    </MenuItem>
                  </ButtonMenu>
                }
              />
              <div className={classes.userSearchContainer}>
                <div className={classes.autosuggestInput}>
                  <UserAutosuggest
                    organization={this.state.organization}
                    onItemSelected={this.onClick}
                  />
                </div>
              </div>
              <CardContent
                className={classes.settingsCardContent}
                id="user-list"
              >
                <AutoSizer>
                  {({ height, width }) => (
                    <Virtuoso
                      overscan={10}
                      totalCount={this.state.users.length}
                      itemContent={this.userRowRenderer}
                      defaultItemHeight={63}
                      endReached={() => {
                        this.getData();
                      }}
                      components={{
                        Footer: () => {
                          return (
                            <>
                              {!this.state.isAtEnd && (
                                <div
                                  style={{
                                    paddingLeft: "15px",
                                  }}
                                >
                                  {Array.from(Array(5)).map(() => (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Skeleton
                                        width={40}
                                        height={40}
                                        style={{ marginRight: 20 }}
                                        animation="wave"
                                        variant="circle"
                                      />
                                      <div>
                                        <Skeleton
                                          width={300}
                                          height={40}
                                          animation="wave"
                                          style={{ marginBottom: -10 }}
                                        />
                                        <Skeleton
                                          width={250}
                                          height={40}
                                          animation="wave"
                                        />
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </>
                          );
                        },
                      }}
                      style={{ width: width, height: height }}
                    />
                  )}
                </AutoSizer>
              </CardContent>
            </Card>
          </div>
        </div>

        <div className={classes.userSettingsContainer}>
          {Object.keys(this.state.selectedUser).length !== 0 && (
            <Card className={classes.settingsCard}>
              <CardHeader
                title={`${this.state.selectedUser.firstName} ${
                  this.state.selectedUser.surname
                } (${this.state.selectedUser.userLogin})`}
                subheader={
                  this.state.selectedUser.isOperator === 1 ? (
                    <div className={classes.cannotEdit}>
                      <WarningIcon className={classes.cannotEditIcon} />
                      <Trans i18nKey="user_admin_user_cannot_be_edited" />
                    </div>
                  ) : this.userManagedExternally() ? (
                    <div className={classes.cannotEdit}>
                      <WarningIcon className={classes.cannotEditIcon} />
                      <Trans i18nKey="user_admin_user_cannot_be_edited_external_user" />
                    </div>
                  ) : null
                }
                action={
                  <ActionButton
                    color="primary"
                    variant="contained"
                    loading={this.state.saving}
                    id="save-user"
                    disabled={
                      this.state.saveDisabled ||
                      this.state.selectedUser.isOperator === 1 ||
                      this.userManagedExternally()
                    }
                    onClick={this.saveButtonClick}
                  >
                    <DoneIcon />
                    <Trans i18nKey="global_save" />
                  </ActionButton>
                }
              />
              <Tabs
                value={this.state.activeTab}
                onChange={this.handleTabChange}
                className={classes.tabs}
              >
                <Tab label={t("user_admin_profile")} id="user-profile-tab" />
                <Tab label={t("user_admin_settings")} id="user-settings-tab" />
              </Tabs>

              <CardContent className={classes.userSettingsCardContent}>
                {this.state.activeTab === 0 && (
                  <div>
                    <ProfilePage
                      disableAll={
                        this.state.selectedUser.isOperator === 1 ||
                        this.userManagedExternally()
                      }
                      key={this.state.selectedUser.userId}
                      currentUser={this.state.selectedUser}
                      languages={languages}
                      hideSave
                      saveButtonDisable={(saveDisabled) => {
                        this.setState({ saveDisabled });
                      }}
                      stateUpdated={this.profileStateUpdated}
                    />
                  </div>
                )}

                {this.state.activeTab === 1 && (
                  <div className={classes.adminSettings}>
                    <div className={classes.groupDiv}>
                      <InputLabel htmlFor="user-type">
                        <Trans i18nKey="user_admin_user_settings" />
                      </InputLabel>
                      <div style={{ display: "flex" }}>
                        <FormControlLabel
                          className={classes.activeSwitch}
                          id="active"
                          control={
                            <Switch
                              disabled={
                                this.state.selectedUser.isOperator === 1 ||
                                this.userManagedExternally() ||
                                (this.props.licence &&
                                  this.props.licence.usedUsers >=
                                    this.props.licence.namedUsers &&
                                  this.state.selectedUser.inactive === 1)
                              }
                              checked={
                                this.state.selectedUser.inactive === 0
                                  ? true
                                  : false
                              }
                              onChange={this.handleSwitchChange("inactive")}
                              value="active"
                            />
                          }
                          label={t("global_user_active")}
                        />
                      </div>
                    </div>

                    <div
                      style={{ display: "grid" }}
                      className={classes.groupDiv}
                    >
                      <FormLabel component="legend">
                        <Trans i18nKey="user_admin_password_settings" />
                      </FormLabel>
                      <div style={{ display: "flex" }}>
                        <TextField
                          disabled={
                            this.state.selectedUser.isOperator === 1 ||
                            this.userManagedExternally()
                          }
                          id="new-password"
                          label={t("password_label_new_password")}
                          className={classes.passwordInput}
                          value={this.state.newPassword}
                          onChange={this.handleTextFieldChange("newPassword")}
                        />
                        <TextField
                          disabled={
                            this.state.selectedUser.isOperator === 1 ||
                            this.userManagedExternally()
                          }
                          id="new-password-confirm"
                          label={t("user_admin_verify_new_password")}
                          className={classes.passwordInput}
                          value={this.state.newPasswordVerify}
                          onChange={this.handleTextFieldChange(
                            "newPasswordVerify"
                          )}
                        />
                      </div>

                      <FormControlLabel
                        control={
                          <Switch
                            disabled={
                              this.state.selectedUser.isOperator === 1 ||
                              this.userManagedExternally()
                            }
                            checked={
                              this.state.selectedUser.userCanChangePassword ===
                              1
                                ? true
                                : false
                            }
                            onChange={this.handleSwitchChange(
                              "userCanChangePassword"
                            )}
                            value="active"
                          />
                        }
                        label={t("user_admin_can_change_password")}
                      />
                      {/* <FormControlLabel
                        control={
                          <Switch
                            disabled={
                              this.state.selectedUser.isOperator === 1 ||
                              this.userManagedExternally()
                            }
                            checked={
                              this.state.selectedUser.forcePasswordChange === 1
                                ? true
                                : false
                            }
                            onChange={this.handleSwitchChange(
                              "forcePasswordChange"
                            )}
                            value="active"
                          />
                        }
                        label={t("user_admin_force_password_change")}
                      /> */}
                    </div>

                    <FormControl
                      component="fieldset"
                      className={classes.groupDiv}
                    >
                      <FormLabel component="legend">
                        <Trans i18nKey="user_admin_assigned_roles" />
                      </FormLabel>
                      <FormGroup row>
                        {this.state.selectedUser.userPermits && (
                          <>
                            {Object.keys(
                              this.state.selectedUser.userPermits.roles
                            ).map((ele, index) => {
                              if (
                                ele === "systemManager" ||
                                ele === "administrator"
                              ) {
                                return;
                              }
                              return (
                                <FormControlLabel
                                  aria-label={t(`role_${ele}`)}
                                  key={`role-${index}`}
                                  data-value={
                                    this.state.selectedUser.userPermits.roles[
                                      ele
                                    ]
                                  }
                                  control={
                                    <Checkbox
                                      disabled={
                                        this.state.selectedUser.isOperator ===
                                          1 ||
                                        this.state.selectedUser.userId ===
                                          this.props.currentUser.userId ||
                                        this.userManagedExternally() ||
                                        ele === "user" ||
                                        (this.state.selectedUser.userType ===
                                          "limited" &&
                                          ele !== "askExpert") ||
                                        ((this.state.selectedUser.userType ===
                                          "named" ||
                                          this.state.selectedUser.userType ===
                                            "concurrent") &&
                                          ele === "limitedUser")
                                      }
                                      checked={
                                        this.state.selectedUser.userPermits
                                          .roles[ele]
                                      }
                                      onChange={this.handleCheckboxChange(ele)}
                                      value={ele}
                                    />
                                  }
                                  label={t(`role_${ele}`)}
                                />
                              );
                            })}
                          </>
                        )}
                      </FormGroup>
                    </FormControl>
                    <FormControl
                      component="fieldset"
                      className={classes.groupDiv}
                    >
                      <FormLabel component="legend">
                        <Trans i18nKey="user_admin_system_roles" />
                      </FormLabel>
                      <FormGroup row>
                        {this.state.selectedUser.userPermits && (
                          <>
                            {Object.keys(
                              this.state.selectedUser.userPermits.roles
                            ).map((ele, index) => {
                              if (
                                ele === "systemManager" ||
                                ele === "administrator"
                              ) {
                                return (
                                  <FormControlLabel
                                    key={`system-role-${index}`}
                                    control={
                                      <Checkbox
                                        disabled={
                                          this.state.selectedUser.isOperator ===
                                            1 ||
                                          this.state.selectedUser.userId ===
                                            this.props.currentUser.userId ||
                                          this.userManagedExternally() ||
                                          this.state.selectedUser.userType ===
                                            "limited" ||
                                          (ele === "systemManager" &&
                                            !currentUserHasRole(
                                              Role.SYSTEM_MANAGER
                                            ))
                                        }
                                        checked={
                                          this.state.selectedUser.userPermits
                                            .roles[ele]
                                        }
                                        onChange={this.handleCheckboxChange(
                                          ele
                                        )}
                                        value={ele}
                                      />
                                    }
                                    label={t(`role_${ele}`)}
                                  />
                                );
                              }
                            })}
                          </>
                        )}
                      </FormGroup>
                    </FormControl>
                    <FormControl
                      component="fieldset"
                      className={classes.groupDiv}
                    >
                      <FormLabel component="legend">
                        <Trans i18nKey="user_admin_assigned_teams" />
                      </FormLabel>
                      <div style={{ display: "flex" }}>
                        {this.state.selectedUser.userPermits &&
                        this.state.selectedUser.userPermits.roles
                          .systemManager ? (
                          <Typography>
                            <Trans i18nKey="user_admin_managers_access_all_teams" />
                          </Typography>
                        ) : (
                          <>
                            {this.state.selectedUser.userId ===
                            this.props.currentUser.userId ? (
                              <Typography>
                                <Trans i18nKey="user_admin_cannot_edit_own_teams" />
                              </Typography>
                            ) : (
                              <>
                                <FormGroup
                                  row
                                  style={{ flex: 0.5, display: "block" }}
                                  id="assigned-teams"
                                >
                                  {this.state.selectedUserTeams.map(
                                    (ele, idx) => {
                                      return (
                                        <Chip
                                          disabled={
                                            this.state.selectedUser
                                              .isOperator === 1 ||
                                            this.userManagedExternally() ||
                                            ele.isDefault
                                          }
                                          key={`team-${idx}`}
                                          label={ele.teamName}
                                          onDelete={this.handleTeamChipDelete(
                                            ele
                                          )}
                                          className={classes.teamChip}
                                        />
                                      );
                                    }
                                  )}
                                </FormGroup>
                                <div style={{ flex: 0.5 }}>
                                  <TextField
                                    id="search-for-team"
                                    label={t("user_admin_search_for_team")}
                                    value={this.state.teamFilter}
                                    className={classes.teamFilterInput}
                                    disabled={
                                      this.state.selectedUser.isOperator ===
                                        1 || this.userManagedExternally()
                                    }
                                    onChange={this.handleTeamFilterChange}
                                  />
                                  <MaterialList
                                    id="available-teams"
                                    style={{
                                      maxHeight: 150,
                                      overflow: "auto",
                                    }}
                                  >
                                    {this.state.teams.map((ele, idx) => {
                                      if (
                                        !this.state.teamFilter ||
                                        (this.state.teamFilter &&
                                          ele.teamName
                                            .toLowerCase()
                                            .includes(
                                              this.state.teamFilter.toLowerCase()
                                            ))
                                      ) {
                                        return (
                                          <ListItem
                                            classes={{
                                              dense: classes.denseList,
                                            }}
                                            key={`team-${idx}`}
                                            dense
                                            button
                                            onClick={this.handleTeamCheckboxChange(
                                              ele
                                            )}
                                            disableGutters
                                          >
                                            <Checkbox
                                              checked={
                                                this.state.selectedUserTeams.filter(
                                                  (e) =>
                                                    e.teamName === ele.teamName
                                                ).length > 0
                                              }
                                              onChange={this.handleTeamCheckboxChange(
                                                ele
                                              )}
                                              value={ele.teamName}
                                              disabled={
                                                this.state.selectedUser
                                                  .isOperator === 1 ||
                                                this.userManagedExternally() ||
                                                ele.isDefault
                                              }
                                              color="primary"
                                            />
                                            <ListItemText
                                              primary={ele.teamName}
                                            />
                                            {ele.isDefault && (
                                              <Chip
                                                className={
                                                  this.props.classes
                                                    .operatorChip
                                                }
                                                label="Default Team"
                                                color="primary"
                                                variant="outlined"
                                              />
                                            )}
                                          </ListItem>
                                        );
                                      }
                                    })}
                                  </MaterialList>
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </FormControl>
                  </div>
                )}
              </CardContent>
            </Card>
          )}
        </div>
        <AddUserDialog
          open={this.state.addUserDialogOpen}
          onClose={this.closeAddUserDialog}
          onSubmit={this.addUserDialogSubmit}
          organization={this.state.organization}
          saving={this.state.savingNewUser}
        />
        <AddTeamDialog
          onClose={() => this.setState({ openAddTeamDialog: false })}
          open={this.state.openAddTeamDialog}
          addTeam={this.addTeam}
        />
        <PasswordRequirementsDialog
          onClose={() =>
            this.setState({ openPasswordRequirementsDialog: false })
          }
          open={this.state.openPasswordRequirementsDialog}
          organization={this.state.organization}
        />
      </div>
    );
  }

  addTeam = (team) => {
    this.setState({
      teams: [team, ...this.state.teams],
      openAddTeamDialog: false,
      teamAdded: team,
    });
    this.props.enqueueSnackbar("Team created", { variant: "success" });
  };

  organizationSelected = (organization) => {
    this.setState({ users: [], selectedUser: {}, organization: organization });
  };
  handlePanelChange = (panel) => (event, expanded) => {
    this.setState({ expandedPanel: expanded ? panel : false });
  };

  profileStateUpdated = (user) => {
    let newUser = Object.assign({}, this.state.selectedUser, user);
    newUser.language = newUser.preferedLanguage;
    newUser.phone = newUser.phoneNumber;
    this.setState({ selectedUser: newUser });
  };

  saveButtonClick = () => {
    this.setState({ saving: true });

    let userPromise = taxServiceClient.patch(
      `/user/${this.state.selectedUser.userId}`,
      {
        language: this.state.selectedUser.preferedLanguage,
        phone: this.state.selectedUser.phoneNumber,
        ...this.state.selectedUser,
        password:
          this.state.newPassword === this.state.newPasswordVerify
            ? this.state.newPassword
            : "",
        teams: this.state.selectedUserTeams,
      }
    );
    // .then((res) => {
    //   this.setState({ selectedUser: res.data });
    // });

    userPromise
      .then((userRes) => {
        this.setState({ saving: false });
        if (userRes.data.userId === this.state.selectedUser.userId) {
          this.props.enqueueSnackbar(this.props.t("user_admin_user_updated"), {
            variant: "success",
          });
          this.setState({ selectedUser: userRes.data });
        }
        fetchLicence();
        taxServiceClient.get(`/user/`).then((res) => {
          let e = {};
          this.setState({
            users: res.data.content,
            unfilteredUsers: res.data.content,
          });
        });

        taxServiceClient
          .patch(`/user/${this.state.selectedUser.userId}/teams`, {
            userId: this.state.selectedUser.userId,
            teamsToAdd: this.state.selectedUserTeams,
            teamsToRemove: this.state.selectedUserTeamsToRemove,
          })
          .then((res) => {
            this.props.enqueueSnackbar(this.props.t("users_teams_updated"), {
              variant: "success",
            });
          })
          .catch((err) => {
            this.props.enqueueSnackbar(
              this.props.t("workflow_error", {
                error: err.response.data.message,
              }),
              {
                variant: "error",
              }
            );
          });
      })
      .catch((err) => {
        this.setState({ saving: false });
        this.props.enqueueSnackbar(
          this.props.t("workflow_error", { error: err.response.data.message }),
          {
            variant: "error",
          }
        );
      });
  };

  openAddUserDialog = () => {
    this.setState({ addUserDialogOpen: true });
  };

  closeAddUserDialog = () => {
    this.setState({ addUserDialogOpen: false });
  };

  addUserDialogSubmit = (user) => {
    this.setState({ savingNewUser: true });
    taxServiceClient
      .post("/user/", {
        language: user.preferedLanguage,
        phone: user.phoneNumber,
        ...user,
      })
      .then((res) => {
        this.props.enqueueSnackbar(this.props.t("user_admin_user_added"), {
          variant: "success",
        });
        this.closeAddUserDialog();
        this.setState({
          users: [res.data, ...this.state.users],
          savingNewUser: false,
        });
        fetchLicence();
      })
      .catch((err) => {
        this.setState({ savingNewUser: false });
        this.props.enqueueSnackbar(
          this.props.t("workflow_error", { error: err.response.data.message }),
          {
            variant: "error",
          }
        );
      });
  };

  handleTabChange = (_e, value) => {
    this.setState({ activeTab: value });
  };

  handleTeamChipDelete = (data) => () => {
    this.setState({
      selectedUserTeams: this.state.selectedUserTeams.filter(
        (ele) => ele.teamName !== data.teamName
      ),
      selectedUserTeamsToRemove: [
        ...this.state.selectedUserTeamsToRemove,
        data,
      ],
    });
  };

  handleCheckboxChange = (name) => (event) => {
    let selectedUser = this.state.selectedUser;
    selectedUser.userPermits.roles[name] = event.target.checked;
    this.setState({ selectedUser });
  };

  handleTextFieldChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleSwitchChange = (name) => (event) => {
    let selectedUser = this.state.selectedUser;
    name === "inactive"
      ? (selectedUser[name] = event.target.checked ? 0 : 1)
      : (selectedUser[name] = event.target.checked ? 1 : 0);

    this.setState({ selectedUser });
  };

  handleSelectChange = (event) => {
    let selectedUser = this.state.selectedUser;
    selectedUser[event.target.name] = event.target.value;
    this.setState({ selectedUser });
  };

  handleTeamCheckboxChange = (team) => () => {
    if (team.isDefault) {
      return;
    }

    let contains =
      this.state.selectedUserTeams.filter(
        (ele) => ele.teamName === team.teamName
      ).length > 0;

    let newTeams;
    let teamsToRemove;
    if (contains) {
      newTeams = this.state.selectedUserTeams.filter(
        (ele) => ele.teamName !== team.teamName
      );
      teamsToRemove = [...this.state.selectedUserTeamsToRemove, team];
    } else {
      if (
        this.state.selectedUser.userType === "limited" &&
        this.state.selectedUserTeams.length >= 2
      ) {
        this.props.enqueueSnackbar(
          this.props.t("limited_user_team_membership_warning"),
          { variant: "warning" }
        );
        newTeams = this.state.selectedUserTeams;
        teamsToRemove = this.state.selectedUserTeamsToRemove.filter(
          (ele) => ele.teamName !== team.teamName
        );
      } else {
        newTeams = [...this.state.selectedUserTeams, team];
        teamsToRemove = this.state.selectedUserTeamsToRemove.filter(
          (ele) => ele.teamName !== team.teamName
        );
      }
    }

    this.setState({
      selectedUserTeams: newTeams,
      selectedUserTeamsToRemove: teamsToRemove,
    });
  };

  userRowRenderer = (index) => {
    const value = this.state.users[index];
    if (!value) {
      return <div style={{ height: 1 }} />;
    }
    return (
      <ListItem dense button onClick={() => this.onClick(value)}>
        <ListItemAvatar>
          <Avatar src={value.avatarBase64} />
        </ListItemAvatar>
        <ListItemText
          primary={
            <>
              {value.firstName || value.surname
                ? `${value.firstName} ${value.surname} (${value.userLogin})`
                : value.userLogin}
              {value.userPermits && value.userPermits.roles["systemManager"] ? (
                <Chip
                  className={this.props.classes.operatorChip}
                  icon={<SupervisorAccountIcon />}
                  label={this.props.t("role_systemManager")}
                  color="primary"
                  variant="outlined"
                />
              ) : null}
              {value.inactive ? (
                <Chip
                  className={this.props.classes.operatorChip}
                  icon={<NotInterestedIcon />}
                  label={this.props.t("user_deactivated")}
                  color="secondary"
                  variant="outlined"
                />
              ) : null}
              {value.provider && value.provider !== "uks" ? (
                <Chip
                  className={this.props.classes.operatorChip}
                  icon={<CloudIcon />}
                  label={this.props.t("external_user")}
                  color="secondary"
                  variant="outlined"
                />
              ) : null}
            </>
          }
          secondary={value.email}
        />
      </ListItem>
    );
  };

  handleTeamFilterChange = (event) => {
    this.setState({ teamFilter: event.target.value });
  };

  onClick = (selectedUser) => {
    this.setState({ selectedUser }, () => {
      taxServiceClient.get(`user/${selectedUser.userId}/team/`).then((res) => {
        if (Object.keys(this.state.selectedUser).length > 0) {
          this.setState({
            selectedUserTeams: res.data.map((ele) => {
              return ele;
            }),
          });
        } else {
          this.setState({
            teams: res.data.map((ele) => {
              return ele;
            }),
          });
        }
      });
    });
  };

  keepUserSuggestion = (user, input) => {
    const inputLength = input.length;

    let loginMatches =
      user.object.userLogin.slice(0, inputLength).toLowerCase() === input;
    let firstNameMatches =
      user.object.firstName.slice(0, inputLength).toLowerCase() === input;
    let surnameMatches =
      user.object.surname.slice(0, inputLength).toLowerCase() === input;
    let emailMatches =
      user.object.email.slice(0, inputLength).toLowerCase() === input;
    // input is a string, id is a number
    let idMatches = user.object.id == input; //eslint-ignore-line eqeqeq

    return (
      loginMatches ||
      firstNameMatches ||
      surnameMatches ||
      emailMatches ||
      idMatches
    );
  };

  getUserSuggestionValue = (suggestion) => {
    return suggestion.object.userLogin;
  };

  renderUserSuggestion = (suggestion, { query, isHighlighted }) => {
    const userLoginMatches = match(suggestion.object.userLogin, query);
    const firstNameMatches = match(suggestion.object.firstName, query);
    const surnameMatches = match(suggestion.object.surname, query);
    const emailMatches = match(suggestion.object.email, query);

    const userLoginParts = parse(suggestion.object.userLogin, userLoginMatches);
    const firstNameParts = parse(suggestion.object.firstName, firstNameMatches);
    const surnameParts = parse(suggestion.object.surname, surnameMatches);
    const emailParts = parse(suggestion.object.email, emailMatches);

    let fnp = firstNameParts.map(
      (part) =>
        part.highlight ? (
          <span key={shortid.generate()} style={{ fontWeight: 500 }}>
            {part.text}
          </span>
        ) : (
          <strong key={shortid.generate()} style={{ fontWeight: 300 }}>
            {part.text}
          </strong>
        )
    );
    fnp.push(" ");

    let lnp = surnameParts.map(
      (part) =>
        part.highlight ? (
          <span key={shortid.generate()} style={{ fontWeight: 500 }}>
            {part.text}
          </span>
        ) : (
          <strong key={shortid.generate()} style={{ fontWeight: 300 }}>
            {part.text}
          </strong>
        )
    );
    lnp.push(" ");

    let ulp = userLoginParts.map(
      (part) =>
        part.highlight ? (
          <span key={shortid.generate()} style={{ fontWeight: 500 }}>
            {part.text}
          </span>
        ) : (
          <strong key={shortid.generate()} style={{ fontWeight: 300 }}>
            {part.text}
          </strong>
        )
    );

    ulp.unshift("(");
    ulp.push(")");

    let ep = emailParts.map(
      (part) =>
        part.highlight ? (
          <span key={shortid.generate()} style={{ fontWeight: 500 }}>
            {part.text}
          </span>
        ) : (
          <strong key={shortid.generate()} style={{ fontWeight: 300 }}>
            {part.text}
          </strong>
        )
    );

    let primaryText = fnp.concat(lnp).concat(ulp);

    return (
      <ListItem
        selected={isHighlighted}
        component="div"
        onClick={() => this.onClick(suggestion.object)}
      >
        <ListItemAvatar>
          <Avatar src={suggestion.object.avatarBase64} />
        </ListItemAvatar>
        <ListItemText
          secondaryTypographyProps={{ noWrap: true }}
          primary={primaryText}
          secondary={ep}
        />
      </ListItem>
    );
  };
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  properties: state.setting.applicationProperties,
  licence: state.setting.licence,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withTranslation()(withSnackbar(UserAdministration))));
